import React from 'react'

class PagePrimaryHero extends React.Component {
  render() {
    const { children } = this.props

    return (
      <section className="pt-lg-8 pb-lg-8 pt-6 pb-5 position-relative bg-primary">
        <div className="img-overlay bg-heading position-absolute is-overlay o-8">
        </div>
        <div className="container">
          <div className="row justify-content-center text-center">
            {children}
          </div>
        </div>
      </section>
    )
  }
}

export default PagePrimaryHero
